
import * as ConfigTypes from 'config/ConfigTypes';
import { getMetaConfig } from "helpers/ConfigHelper";
import { checkRentItemFilter } from "helpers/FilterHelper";

export const CALENDAR_CONTAINER = {
    padding: "20px 5px 5px 5px", display: "flex", background: "white",
    flexDirection: "column", border: "1px solid #ccc",
    fontSize: "13px", borderRadius: "3px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.6)"
};

export const CALENDAR_BOX = {
    display: "flex", borderBottom: "1px solid #ccc",
    marginBottom: "10px", paddingLeft: "10px", height: "30px"
}

export const CALENDAR_CHOOSE_BTN = {
    height: "25px", background: "black", color: "white", width: "420px",
    border: "none", borderRadius: "3px"
};

export const CALENDAR_OK_BTN = {
    ...CALENDAR_CHOOSE_BTN, width: "60px", marginLeft: "5px",
};

export const CALENDAR_OPTIONS = {
    weekday: 'short', year: 'numeric',
    month: 'short', day: 'numeric'
};

export const getStartEndDates = ({ selectedDates }) => {
    let dateObj = { start: "", end: "" };
    if (selectedDates && selectedDates.length > 0) {
        let sortedDates = selectedDates.sort(function (a, b) { return a.getTime() - b.getTime() });
        let last = sortedDates.length - 1;
        dateObj.start = sortedDates[0].toLocaleDateString('de-DE', CALENDAR_OPTIONS);
        dateObj.end = sortedDates[last].toLocaleDateString('de-DE', CALENDAR_OPTIONS);
    }
    return dateObj;
}


export const canShow = ({ item, props }) => {
    if (checkRentItemFilter({ el: item })) {
        return true;
    }
    return false;
}

export const parseDateStr = (str) =>  {
  const year = Number(str.slice(0, 4));
  let month = Number(str.slice(4, 6)); // 1–12
  month = month - 1; // for react-datepicker 
  const day = Number(str.slice(6, 8));

  return { year, month, day };
}

export const changeDateToStr = ({dates}) => {
    let str;
    if(dates && dates.length){
        let date = dates[0];
        let tmp = date.setHours(date.getHours() + 2);
        let dateObj = new Date(tmp);
        str = dateObj.toISOString().split('T')[0];
        str = str.replace(/-/g, "");
        return str;
    }
}